

















import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { openList } from '@/main/router/routerPath';
import { apiProvider as nationaAccountProvider } from '@/modules/oem/NationalAccount/api';
import { mapActions } from 'vuex';
import { PAGE_MGR_CLEAR } from '@/main/store/actionTypes';

import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	methods: {
		...mapActions({
			clearPages: `pageManager/${PAGE_MGR_CLEAR}`,
		}),
		async saveClick() {
			if (await this.validate()) {
				this.startLoading();
				const { data: nationalAccountId } = await nationaAccountProvider.saveNationalAccountData(this.edit);
				if (nationalAccountId === 0) {
					this.showErrorAlert({ message: 'NATIONAL_ACCOUNT_EXISTS' });
					this.endLoading();
					return false;
				}
				this.refreshPreviousPage = true;
				this.openNationalAccountList();
				this.endLoading();
			}
			return true;
		},
		async deleteClick() {
			this.startLoading();
			const { data: isNationalAccountDelete } = await nationaAccountProvider.deleteNationalAccountData(this.edit.Id);
			if (!isNationalAccountDelete) {
				this.showErrorAlert({ message: 'NATIONAL_ACCOUNT_DELETE' });
				this.endLoading();
				return false;
			}
			this.refreshPreviousPage = true;
			this.openNationalAccountList();
			this.endLoading();
			return true;
		},
		async openNationalAccountList(checkFilters = true) {
			await this.clearPages();
			openList(NAME, { checkFilters });
		},
	},
});
